import React, { useEffect, useRef, useState } from "react";
import { useLocation, Routes, Route, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import CirclesLoader from "../layouts/CirclesLoader";
import Header from "classic/components/Navbars/Header";
import Footer from "classic/components/Footer/Footer";
import Sidebar from "classic/components/Sidebar/Sidebar";
import { getParameterFromManager } from "services/Utils";
import { signOutUser } from "services/Helper";
import { Modal } from "react-bootstrap";
import routes from "routes.js";
import SubmissionsList from "classic/views/SubmissionsList.js";

function AuthenticatedLayout({ toggleSwitchUI }) {
  const location = useLocation();
  const navigate = useNavigate();
  const mainPanel = useRef(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enableTriage, setEnableTriage] = useState(false);
  const [submissionModal, setSubmissionModal] = useState(false);
  const [showClaims, setShowClaims] = useState(false);

  const getRoutes = (routes) => {
    const isAuthUser = routes.some(
      (route) => route.layout === "/user" && route.path !== "/undefined"
    );
    if (isAuthUser) {
      routes.push({
        path: "/submissions/qatool/:id/*",
        name: "QA Tool",
        component: SubmissionsList,
        layout: "/user",
      });
    }
    return routes.map((prop, key) =>
      prop.layout === "/user" && prop.path !== "/undefined" ? (
        <Route
          key={key}
          path={prop.layout + prop.path}
          element={
            <prop.component
              submissionModal={submissionModal}
              setSubmissionModal={setSubmissionModal}
            />
          }
        />
      ) : null
    );
  };

  useEffect(() => {
    async function checkUserAnAdmin() {
      setLoading(true);
      try {
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        const groups = user.signInUserSession.idToken.payload["cognito:groups"];
        setIsAdmin(groups?.includes("MEA_ADMIN") || false);

        const showClaimsPS = await getParameterFromManager("SHOW_CLAIMS_UI");
        setShowClaims(showClaimsPS);

        if (["/user/submissions", "/user/claims"].includes(location.pathname)) {
          navigate(showClaimsPS ? "/user/claims" : "/user/submissions");
        }

        const enableTriagePS = await getParameterFromManager("ENABLE_TRIAGE");
        setEnableTriage(enableTriagePS);
      } catch (err) {
        if (err === "The user is not authenticated") {
          signOutUser();
        }
      } finally {
        setLoading(false);
      }
    }
    checkUserAnAdmin();

    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanel.current) mainPanel.current.scrollTop = 0;

    if (
      window.innerWidth < 993 &&
      document.documentElement.classList.contains("nav-open")
    ) {
      document.documentElement.classList.remove("nav-open");
      const element = document.getElementById("bodyClick");
      if (element) element.parentNode.removeChild(element);
    }
  }, [location.pathname, navigate, showClaims]);

  function getRouteMap(isAdmin, enableTriage, showClaims) {
    let routesToUse = [...(isAdmin ? routes[1] : routes[0])];

    if (!enableTriage) {
      routesToUse = routesToUse.filter((route) => route.name !== "Triage");
    }

    routesToUse = routesToUse.filter((route) =>
      showClaims ? route.name !== "Submissions" : route.name !== "Claims"
    );

    return routesToUse;
  }

  return (
    <>
      <div className="wrapper">
        <Sidebar
          color="black"
          routes={getRouteMap(isAdmin, enableTriage, showClaims)}
        />
        <div className="main-panel" ref={mainPanel}>
          <Header
            submissionModal={submissionModal}
            setSubmissionModal={setSubmissionModal}
            toggleSwitchUI={toggleSwitchUI}
          />
          <div className="content p-0">
            <Routes>
              {getRoutes(getRouteMap(isAdmin, enableTriage, showClaims))}
              {!loading && (
                <Route
                  path="/*"
                  element={
                    <div className="bad-url">
                      <span>404 - Page Not Found.</span>
                    </div>
                  }
                />
              )}
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
      <Modal
        className="modal-centre new-modal"
        backdrop="static"
        keyboard={false}
        show={loading}
        animation={false}
        centered={true}
      >
        <Modal.Body className="text-center">
          <CirclesLoader isLoading={loading} />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AuthenticatedLayout;
